import { createContext, useContext } from "react";

import { ProductPickerContextType } from "@src/components/MainApp/SharedProductPicker/types";

export const ProductPickerContext = createContext<ProductPickerContextType>(
  undefined as unknown as ProductPickerContextType
);

export const useProductPickerContext = () => useContext(ProductPickerContext);
